














import { filterMixin } from '@/utils/mixins/filterMixin'
import Autocomplete from '@/components/Autocomplete.vue'
import { getAgencies } from '@/api/Agency/agency.api'
import FlatFilter from '~/components/FlatFilter.vue'

export default filterMixin.extend({
  components: {
    appAutocomplete: Autocomplete,
    FlatFilter,
  },
  data() {
    return {
      getAgencies,
      loading: {
        services: false,
      },
    }
  },
})
